import { getAuth, signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { db } from "./firebase";
import logo from "./assets/logo.png";
import {
  collection,
  onSnapshot,
  doc,
  updateDoc,
  addDoc,
  getDocs,
  deleteDoc
} from "firebase/firestore";

const COURTS = [
  { id: "box1", name: "Box 1" },
  { id: "box2", name: "Box 2" },
  { id: "bigbox", name: "Big Box" },
  { id: "net1", name: "Net 1" },
  { id: "net2", name: "Net 2" }
];

function Admin() {
  const [slots, setSlots] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  // ✅ AUTH CHECK
  useEffect(() => {
    const auth = getAuth();

    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (!user) {
        navigate("/login");
      } else if (user.email !== "admin@rainbowplayarena.com") {
        alert("Access denied. Admin only.");
        navigate("/login");
      } else {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  // ✅ LOGOUT
  const handleLogout = async () => {
    const auth = getAuth();
    await signOut(auth);
    window.location.href = "/login";
  };

  // ✅ FETCH DATA
  useEffect(() => {
    const unsub1 = onSnapshot(collection(db, "slots"), (snap) => {
      setSlots(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    });

    const unsub2 = onSnapshot(collection(db, "bookings"), (snap) => {
      setBookings(snap.docs.map(d => d.data()));
    });

    return () => {
      unsub1();
      unsub2();
    };
  }, []);

  // ✅ GENERATE 24HR SLOTS
  const generateSlots = async () => {
  const confirmGen = window.confirm("Generate fresh 30 days slots?");
  if (!confirmGen) return;

  let createdCount = 0;

  for (let i = 0; i < 30; i++) {
    const d = new Date();
    d.setDate(d.getDate() + i);
    const dateStr = d.toISOString().split("T")[0];

    for (let hour = 0; hour < 24; hour++) {
      const nextHour = (hour + 1) % 24;
      const time = `${hour}:00-${nextHour}:00`;

      await addDoc(collection(db, "slots"), {
        date: dateStr,
        time,
        status: "available",
        bookedCourts: []
      });

      createdCount++;
    }
  }

  alert(`✅ ${createdCount} slots created (30 days)`);
};

  // ✅ RESET
  const resetSlots = async () => {
  const confirmReset = window.confirm("⚠️ Delete all slots?");
  if (!confirmReset) return;

  const snapshot = await getDocs(collection(db, "slots"));

  const deletePromises = snapshot.docs.map((docSnap) =>
    deleteDoc(doc(db, "slots", docSnap.id))
  );

  await Promise.all(deletePromises); // 🔥 FAST DELETE

  alert("🧹 All slots deleted");

  await generateSlots();
};
// ✅ BLOCK FULL DAY
const blockFullDay = async () => {
  const confirmBlock = window.confirm("Block all slots for this day?");
  if (!confirmBlock) return;

  const daySlots = slots.filter(s => s.date === selectedDate);

  await Promise.all(
    daySlots.map(s => {
      const ref = doc(db, "slots", s.id);
      return updateDoc(ref, { status: "blocked" });
    })
  );

  alert("All slots blocked");
};

// ✅ UNBLOCK FULL DAY
const unblockFullDay = async () => {
  const confirmUnblock = window.confirm("Unblock all slots?");
  if (!confirmUnblock) return;

  const daySlots = slots.filter(s => s.date === selectedDate);

  await Promise.all(
    daySlots.map(s => {
      const ref = doc(db, "slots", s.id);
      return updateDoc(ref, { status: "available" });
    })
  );

  alert("All slots unblocked");
};
  const toggleBlockSlot = async (slot) => {
    const ref = doc(db, "slots", slot.id);
    const newStatus = slot.status === "blocked" ? "available" : "blocked";
    await updateDoc(ref, { status: newStatus });
  };

  // ✅ TIME UTILS (FIXED FOR 24HR)
  const getHour = (time) => parseInt(time.split(":")[0]);

  const sortSlots = (slots) =>
  [...slots].sort((a, b) => getHour(a.time) - getHour(b.time));

  const isPremiumSlot = (time) => {
    const hour = getHour(time);
    return (hour >= 5 && hour < 10) || (hour >= 17 && hour < 24);
  };
console.log("DATES:", [...new Set(slots.map(s => s.date))]);

  const now = new Date();

const filteredSlots = sortSlots(
  selectedDate
    ? slots.filter(s => {
        if (s.date !== selectedDate) return false;

        // ✅ If NOT today → show all
        const today = new Date().toISOString().split("T")[0];
        if (selectedDate !== today) return true;

        // ✅ If today → filter past time
        const slotHour = parseInt(s.time.split(":")[0]);

        const slotDateTime = new Date(s.date);
        slotDateTime.setHours(slotHour, 0, 0, 0);

        return slotDateTime > now;
      })
    : slots
);

  const getBookingsForSlot = (slot) =>
    bookings.filter(
      b => b.date === slot.date && b.time === slot.time
    );

  const totalRevenue = bookings.reduce(
    (sum, b) => sum + (b.amount || 0),
    0
  );

  const todayRevenue = bookings
    .filter(b => b.date === selectedDate)
    .reduce((sum, b) => sum + (b.amount || 0), 0);

  if (loading) return <div>Checking authentication...</div>;

  return (
    <div style={{ padding: 20 }}>

      {/* HEADER */}
      <div style={{ textAlign: "center", marginBottom: 15 }}>
        <img src={logo} alt="Logo" style={{ width: 160 }} />
        <h2>Admin Panel</h2>
      </div>

      {/* ACTION BUTTONS */}
      <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
  <button onClick={handleLogout}>
    Logout
  </button>

  <button
    onClick={generateSlots}
    style={{
      padding: "10px 16px",
      borderRadius: 8,
      border: "none",
      background: "#2563eb",
      color: "white"
    }}
  >
    ⚡ Generate 24hr Slots
  </button>

  <button
    onClick={resetSlots}
    style={{
      padding: "10px 16px",
      borderRadius: 8,
      border: "none",
      background: "#ef4444",
      color: "white"
    }}
  >
    🧹 Reset Slots
  </button>
</div>

      {/* STATS */}
      <div style={{ display: "flex", gap: 15, marginBottom: 20 }}>
        <div>💰 ₹{totalRevenue}</div>
        <div>📅 ₹{todayRevenue}</div>
        <div>📊 {bookings.length}</div>
      </div>
      {/* ✅ DATE STRIP (ADD THIS) */}
<div style={{ display: "flex", overflowX: "auto", gap: 10, marginBottom: 20 }}>
  {[...Array(10)].map((_, i) => {
    const d = new Date();
    d.setDate(d.getDate() + i);
    const formatted = d.toISOString().split("T")[0];

    const isSelected = selectedDate === formatted;

    return (
      <div
        key={i}
        onClick={() => setSelectedDate(formatted)}
        style={{
          minWidth: 90,
          padding: 10,
          borderRadius: 12,
          cursor: "pointer",
          textAlign: "center",
          background: isSelected ? "#22c55e" : "#334155",
          color: "white"
        }}
      >
        <div style={{ fontSize: 12 }}>
          {i === 0
            ? "Today"
            : i === 1
            ? "Tomorrow"
            : d.toLocaleDateString("en-US", { weekday: "short" })}
        </div>

        <div style={{ fontWeight: "bold" }}>
          {d.getDate()}
        </div>
      </div>
    );
  })}
</div>
      {/* ✅ BLOCK FULL DAY BUTTONS */}
<div style={{ marginBottom: 20 }}>
  <button
    onClick={blockFullDay}
    style={{
      padding: "10px 16px",
      borderRadius: 8,
      border: "none",
      background: "#ef4444",
      color: "white",
      marginRight: 10
    }}
  >
    🚫 Block Full Day
  </button>

  <button
    onClick={unblockFullDay}
    style={{
      padding: "10px 16px",
      borderRadius: 8,
      border: "none",
      background: "#22c55e",
      color: "white"
    }}
  >
    ✅ Unblock Full Day
  </button>
</div>

      {/* SLOT LIST */}
      {filteredSlots.map((slot) => {
        const slotBookings = getBookingsForSlot(slot);
        const bookedIds = slotBookings.map(b => b.courtId);
        const now = new Date();
const slotHour = parseInt(slot.time.split(":")[0]);

const slotDateTime = new Date(`${slot.date}T${slot.time.split("-")[0]}:00`);
slotDateTime.setHours(slotHour, 0, 0, 0);

const isPast = slotDateTime <= now;

        return (
          <div
            key={slot.id}
            style={{
              marginBottom: 15,
              padding: 15,
              borderRadius: 12,
              background: isPast
  ? "#111827"
  : isPremiumSlot(slot.time)
  ? "#3b2f00"
  : "#1e293b"
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <b>{slot.date}</b>
              <b>{slot.time}</b>
              {slot.status === "blocked" && (
  <div style={{ color: "#ef4444", fontWeight: "bold", marginTop: 4 }}>
    🚫 BLOCKED
  </div>
)}
            </div>
            {isPast && (
  <div style={{ color: "#94a3b8", fontSize: 12, marginTop: 4 }}>
    ⏳ Past Slot
  </div>
)}

            {isPremiumSlot(slot.time) && (
              <div style={{ color: "#facc15" }}>
                ⭐ Premium Slot
              </div>
            )}

            {COURTS.map(c => (
              <span key={c.id}>
                {c.name} {bookedIds.includes(c.id) ? "❌" : "✅"}
              </span>
            ))}

            <button
  disabled={isPast}
  onClick={() => toggleBlockSlot(slot)}
  style={{
    marginTop: 10,
    padding: "6px 10px",
    borderRadius: 6,
    border: "none",
    background: slot.status === "blocked" ? "#22c55e" : "#ef4444",
    color: "white",
    cursor: "pointer"
  }}
>
              {slot.status === "blocked" ? "Unblock" : "Block"}
            </button>
          </div>
        );
      })}
    </div>
  );
}

export default Admin;